// During a VERBAL question the candidate's speech is their graded answer, so it isn't sent to the
// AI interviewer as a chat turn (the AI would talk over the answer). The one exception is speech
// clearly addressed TO the AI - "I'm done", "next question", "end the interview", "can you repeat
// the question", "are you there" - which must still reach it, otherwise the AI looks deaf until
// the candidate clicks Submit. Kept to short utterances so a phrase inside a longer spoken answer
// ("...once I'm done with the schema I would move on to indexing...") doesn't trigger it.

const MAX_WORDS = 25

const ADDRESSED_TO_AI_PATTERNS: RegExp[] = [
  /\b(end|stop|finish|terminate|quit|close|wrap up)\b.{0,20}\binterview\b/,
  /\binterview\b.{0,20}\b(end|over|stop|finish)/,
  /\b(i'?m|i am|im)\s+(done|finished|through)\b/,
  /\b(that'?s|that is)\s+(all|it|my answer)\b/,
  /\b(next|another|different)\s+question\b/,
  /\bmove\s+(on|forward|ahead)\b/,
  /\b(go|proceed)\s+(to\s+the\s+)?next\b/,
  /\bskip\b/,
  /\b(don'?t|do not)\s+know\b/,
  /\b(no|not)\s+(idea|sure about this)\b/,
  /\b(give|giving)\s+up\b/,
  /\b(repeat|rephrase|clarify|explain)\b.{0,25}\bquestion\b/,
  /\b(say|read)\s+(that|it|the question)\s+again\b/,
  /\bwhat do you mean\b/,
  /\b(are|r)\s+you\s+there\b/,
  /\bcan\s+you\s+hear\s+me\b/,
]

export function isAddressedToAi(text: string): boolean {
  const normalized = (text || '').toLowerCase().replace(/[’`]/g, "'").replace(/\s+/g, ' ').trim()
  if (!normalized) return false
  if (normalized.split(' ').length > MAX_WORDS) return false
  return ADDRESSED_TO_AI_PATTERNS.some((pattern) => pattern.test(normalized))
}
